import React, { useEffect, useState } from "react";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { FaRegCalendarXmark } from "react-icons/fa6";
import { FaRegCalendarMinus } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";
import { LuLogIn } from "react-icons/lu";
import { LuLogOut } from "react-icons/lu";
import DataCard from "../component/DataCard";
import { Link, useNavigate } from "react-router-dom";
import { LuTimer } from "react-icons/lu";
import { CiCalendar } from "react-icons/ci";
import { GoPencil } from "react-icons/go";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { DatePicker, MobileTimePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { SERVER_URL } from "../constant";
import axios from "axios";
import AlertBox from "../component/AlertBox";
import DialogBox from "../component/DialogBox";
import ButtonCompo from "../component/ButtonCompo";
import SelectField from "../component/SelectField";
import RadioCompo from "../component/RadioCompo";

function Attendance() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [attendanceRecord, setAttendanceRecord] = useState([]);
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [attendanceReq, setAttendanceReq] = useState("");
  const [reason, setReason] = useState("");
  const [place, setPlace] = useState("");
  const [selectedDate, setSelectedDate] = useState();
  const [clockIn, setClockIn] = useState();
  const [clockOut, setClockOut] = useState();
  const [explanation, setExplanation] = useState("");
  const [attendanceReqData, setAttedanceReqData] = useState([]);
  const [tableSwitch, setTableSwitch] = useState("AH");

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // fetch attendance
  async function getAttendance() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/attendance/get/all?startDate=${startDate?.$d?.toString()}&endDate=${endDate?.$d?.toString()}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setAttendanceRecord(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  // fetch attendance info
  async function getAttendanceInfo() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/attendance/get/info`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setAttendanceInfo(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  // fetch attendance requests
  async function getAttendanceReq() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/attendance/get/requests/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setAttedanceReqData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAttendanceReq();
  }, []);

  // attendance request
  async function attendanceApply() {
    console.log(selectedDate?.$d?.toString());
    console.log(attendanceReq);
    console.log(reason);
    console.log(place);
    console.log(selectedDate?.$d);
    console.log(new Date(clockIn?.$d).toLocaleTimeString()?.toString());
    console.log(new Date(clockOut?.$d).toLocaleTimeString()?.toString());
    console.log(explanation);
    if (attendanceReq === "Shift Change") {
      if (
        reason.length === 0 ||
        place.length === 0 ||
        explanation.length === 0 ||
        clockIn === undefined ||
        clockOut === undefined
      ) {
        setOpen(true);
        setMessage("All fields are required");
        return null;
      }
    } else {
      if (
        reason.length === 0 ||
        place.length === 0 ||
        explanation.length === 0 ||
        selectedDate === undefined ||
        clockIn === undefined ||
        clockOut === undefined
      ) {
        setOpen(true);
        setMessage("All fields are required");
        return null;
      }
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/attendance/request`,
        method: "post",
        data: {
          date: selectedDate?.$d?.toString(),
          reqType: attendanceReq,
          reason: reason,
          place: place,
          clockIn: new Date(clockIn?.$d).toLocaleTimeString()?.toString(),
          clockOut: new Date(clockOut?.$d).toLocaleTimeString()?.toString(),
          explanation: explanation,
          managerId: employeeData?.manager,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Application requested successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
      setAttendanceReq("");
      setReason("");
      setPlace("");
      setSelectedDate(undefined);
      setClockIn(undefined);
      setClockOut(undefined);
      setExplanation("");
    }
  }

  useEffect(() => {
    getAttendanceInfo();
  }, []);

  useEffect(() => {
    getAttendance();
  }, [startDate, endDate]);

  const attendanceReqType = [
    {
      title: "Attendance Request",
      value: "Attendance Request",
    },
    {
      title: "Shift Change",
      value: "Shift Change",
    },
    {
      title: "Out of Duty",
      value: "Out of Duty",
    },
  ];

  const reasonArray = [
    {
      title: "Technical Issue",
      value: "Technical Issue",
    },
    {
      title: "Forgot Marking Attendance",
      value: "Forgot Marking Attendance",
    },
    {
      title: "Missed to clock in or clock out",
      value: "Missed to clock in or clock out",
    },
    {
      title: "Business Travel",
      value: "Business Travel",
    },
    {
      title: "Other",
      value: "Other",
    },
  ];

  const shiftChangeReason = [
    {
      title: "Based on Projects",
      value: "Based on Projects",
    },
  ];

  const placeArr = [
    {
      title: "Office",
      value: "Office",
    },
    {
      title: "Home",
      value: "Home",
    },
  ];

  const tableSwitchData = [
    {
      title: "My Attendances",
      value: "AH",
    },
    {
      title: "Attendances Requests",
      value: "AR",
    },
  ];

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex flex-col justify-center items-center py-5">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw]">
          <h1 className="text-[30px] font-medium text-left w-full">
            Attendance
          </h1>
          <div className="w-full flex justify-end items-end">
            <DialogBox
              trigger={
                <ButtonCompo variant={"outlined"}>
                  Attendance Request
                </ButtonCompo>
              }
              title="Request An Attendance"
              actionButton={
                <ButtonCompo onClick={attendanceApply}>submit</ButtonCompo>
              }
              closeActionButton={<ButtonCompo>cancel</ButtonCompo>}
            >
              <div className="w-full space-y-5">
                <SelectField
                  label={"Attendance Request *"}
                  valueArray={attendanceReqType}
                  setValue={(e) => setAttendanceReq(e?.target?.value)}
                />
                <SelectField
                  label={"Reason *"}
                  valueArray={
                    attendanceReq === "Shift Change"
                      ? shiftChangeReason
                      : reasonArray
                  }
                  setValue={(e) => setReason(e?.target?.value)}
                />
                <SelectField
                  label={"Place *"}
                  valueArray={placeArr}
                  setValue={(e) => setPlace(e?.target?.value)}
                />
                {attendanceReq !== "Shift Change" ? (
                  <DatePicker
                    label="Date *"
                    className="!w-full"
                    onChange={setSelectedDate}
                  />
                ) : (
                  ""
                )}
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <MobileTimePicker label="Clock In" onChange={setClockIn} />
                  <MobileTimePicker label="Clock Out" onChange={setClockOut} />
                </div>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Explanation *"
                  multiline
                  className="!w-full"
                  onChange={(e) => setExplanation(e?.target?.value)}
                />
              </div>
            </DialogBox>
          </div>
          <div className="w-full mt-5">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6 gap-3">
              <DataCard
                title={"Present Days"}
                value={attendanceInfo?.totalPresent?.present || 0}
                icon={<FaRegCalendarCheck />}
              />
              <DataCard
                title={"Leave Days"}
                value={attendanceInfo?.totalLeave?.leave || 0}
                icon={<FaRegCalendarMinus />}
              />
              <DataCard
                title={"Absent"}
                value={attendanceInfo?.totalAbsent?.absent || 0}
                icon={<FaRegCalendarXmark />}
              />
              <DataCard
                title={"Avarage Work Duration"}
                value={
                  <p className="font-semibold">
                    {attendanceInfo?.avarageWorkingHours?.avarage?.toFixed(2)}{" "}
                    <span className="text-[15px] font-medium">hours</span>
                  </p>
                }
                icon={<LuTimer />}
              />
              <DataCard
                title={"Start Shift"}
                value={employeeData?.startShieftTime}
                icon={<IoIosTimer />}
              />
              <DataCard
                title={"End Shift"}
                value={employeeData?.endShieftTime}
                icon={<IoIosTimer />}
              />
            </div>
          </div>
          <div className="w-full mt-10">
            <div className="w-full">
              <p className="text-[17px] font-medium mb-3 text-slate-800">
                Filter
              </p>
              <div className="justify-between flex flex-col gap-3 sm:flex-row">
                <section className="flex gap-2 items-center">
                  <DatePicker
                    label="Start Date"
                    onChange={(e) => setStartDate(e)}
                  />
                  <DatePicker
                    label="End Date"
                    onChange={(e) => setEndDate(e)}
                  />
                </section>
              </div>
            </div>
            <div className="mt-5">
              <RadioCompo
                valueArray={tableSwitchData}
                value={tableSwitch}
                onChange={(e) => setTableSwitch(e?.target?.value)}
              />
            </div>
            <div className="w-full mt-5 border">
              {tableSwitch === "AH" ? (
                <div className="overflow-auto">
                  <Table area-label="simple table">
                    <TableHead>
                      <TableRow className="bg-blue-500">
                        <TableCell className="!text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Date <CiCalendar size={"19px"} />
                          </p>
                        </TableCell>
                        <TableCell className="!text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Day <CiCalendar size={"19px"} />
                          </p>
                        </TableCell>
                        <TableCell className=" !text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Time In <LuLogIn size={"19px"} />
                          </p>
                        </TableCell>
                        <TableCell className=" !text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Time Out <LuLogOut size={"19px"} />
                          </p>
                        </TableCell>
                        <TableCell className="!text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Work Duration <IoIosTimer size={"19px"} />
                          </p>
                        </TableCell>
                        <TableCell className="!text-white">
                          <p className="flex justify-center items-center w-full font-medium gap-2 text-center">
                            Status <GoPencil size={"19px"} />
                          </p>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {attendanceRecord.map((e, i) => (
                        <TableRow className="hover:bg-slate-100/70 cursor-pointer">
                          <TableCell className="!text-center">{`${
                            e?.dayOfMonth
                          }-${Number(e?.month) + 1}-${e?.year}`}</TableCell>
                          <TableCell className="!text-center">
                            {new Date(
                              `${e?.year}-${Number(e?.month) + 1}-${
                                e?.dayOfMonth
                              }`
                            ).toLocaleDateString("en-US", { weekday: "long" })}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.actualLoginTimeStamp || "--:--"}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.actualLogoutTimeStamp || "--:--"}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.totalWorkingHours || "--"}
                          </TableCell>
                          <TableCell className="!text-center">
                            <span
                              className={`${
                                e?.status === "Present"
                                  ? "bg-green-300/30 text-green-800"
                                  : e?.status === "Weekly Holiday"
                                  ? "bg-blue-300/30 text-blue-800"
                                  : e?.status === "Absent"
                                  ? "bg-red-300/30 text-red-800"
                                  : "bg-slate-300/30 text-slate-800"
                              } font-medium px-3 p-1 rounded-full text-center`}
                            >
                              {e?.status === "Leave" ? "On Leave" : e?.status}
                            </span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    {/* <TablePagination /> */}
                  </Table>
                </div>
              ) : (
                <div className="overflow-auto">
                  <Table>
                    <TableHead>
                      <TableRow className="bg-blue-500">
                        <TableCell className="!text-white !text-center">
                          Date
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Clock In
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Clock Out
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Place
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Attendance Type
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Reason
                        </TableCell>
                        <TableCell className="!text-white !text-center">
                          Remarks
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {attendanceReqData?.map((e, i) => (
                        <TableRow>
                          <TableCell className="!text-center">
                            {`${e?.dayOfMonth}-${Number(e?.month) + 1}-${
                              e?.year
                            }`}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.clockin}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.clockout}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.place}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.reqType}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.reason}
                          </TableCell>
                          <TableCell className="!text-center">
                            {e?.remarks}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Attendance;
